import { Menu, Wallet, LogOut, User } from 'lucide-react';
import { useTenant } from './MockTenantProvider';
import { useDashboardData } from './MockDashboardDataProvider';

/**
 * HarnessTopbar - Clerk-free topbar for UI Harness
 * 
 * IMPORTANT: This is ONLY for /__ui-harness routes
 * Does NOT use Clerk components
 * Shows mock user data
 */
export default function HarnessTopbar({ variant = 'customer', onMenuClick }) {
  const { tenant } = useTenant() || {};
  const { walletStatus } = useDashboardData() || {};

  const isAdmin = variant === 'admin';

  return (
    <header className="fixed top-0 right-0 left-0 lg:left-64 z-30 h-16 bg-white border-b border-gray-200">
      <div className="h-full px-4 flex items-center justify-between gap-4">
        {/* Left: Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
        >
          <Menu className="w-5 h-5 text-gray-600" />
        </button>

        {/* Center: Business selector (customer only) or Admin label */}
        <div className="flex-1">
          {isAdmin ? (
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" />
              <span className="text-sm font-medium text-gray-700">Admin Panel</span>
            </div>
          ) : (
            <div className="hidden sm:block">
              {tenant?.business && (
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                    <span className="text-sm font-bold text-orange-600">
                      {tenant.business.name.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900 truncate max-w-[200px]">
                      {tenant.business.name}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Right: SMS Balance + User Menu */}
        <div className="flex items-center gap-4">
          {/* SMS Balance (customer only) */}
          {!isAdmin && walletStatus && (
            <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-orange-50 rounded-lg border border-orange-200">
              <Wallet className="w-4 h-4 text-orange-600" />
              <span className="text-sm font-semibold text-orange-900">
                {walletStatus.sms_remaining?.toLocaleString() || '0'} SMS
              </span>
            </div>
          )}

          {/* Mock User Menu */}
          <div className="flex items-center gap-3">
            {/* Mock User Avatar */}
            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <User className="w-4 h-4 text-white" />
            </div>
            
            {tenant?.user && (
              <div className="hidden lg:block">
                <p className="text-sm font-medium text-gray-900 truncate max-w-[150px]">
                  {tenant.user.first_name || 'User'}
                </p>
              </div>
            )}
            <button 
              onClick={() => console.log('[UI Harness] Mock sign out')}
              className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              title="Sign Out (Mock)"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
